import {
  Button,
  ButtonElementTypes,
  ButtonSkinPrimary,
  ButtonSkinTertiary,
} from '@picsart/design-system/components/Button';
import { IconChevronLeftSmall } from '@picsart/design-system/foundation/icons/IconChevronLeftSmall';
import { IconChevronRightSmall } from '@picsart/design-system/foundation/icons/IconChevronRightSmall';

import { useTranslator } from '@picsart/rc/services/localization';

import { ItemProps, ItemType } from './types';

import { useItemStyles } from './styles';

function Item({ page, isActive, currentPage, setCurrentPage }: ItemProps) {
  const translate = useTranslator();
  const classes = useItemStyles();

  switch (page) {
    case ItemType.Start: {
      return (
        <Button
          dataTestId="prev"
          tag={ButtonElementTypes.Link}
          className={classes.circle}
          centerIcon={IconChevronLeftSmall}
          rel="prev"
          skin={ButtonSkinTertiary}
          onClick={() => setCurrentPage(currentPage - 1)}
        />
      );
    }
    case ItemType.End: {
      return (
        <Button
          dataTestId="next"
          tag={ButtonElementTypes.Link}
          className={classes.circle}
          centerIcon={IconChevronRightSmall}
          rel="next"
          skin={ButtonSkinTertiary}
          onClick={() => setCurrentPage(currentPage + 1)}
        />
      );
    }

    case ItemType.Dots: {
      return <span className={classes.dots}>...</span>;
    }

    default: {
      const skin = isActive ? ButtonSkinPrimary : ButtonSkinTertiary;

      return (
        <Button
          tag={ButtonElementTypes.Link}
          skin={skin}
          className={classes.circle}
          data-pulse-name={page}
          onClick={() => setCurrentPage(page)}
        >
          {translate(String(page))}
        </Button>
      );
    }
  }
}

export default Item;
